import { SendOutlined } from '@ant-design/icons';

import { makeStyles } from '@mui/styles';

import {
    Button,
    Checkbox,
    FormControl,
    InputLabel,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Select,
    Modal as MuiModal,
} from '@mui/material'


import { Chat , Close } from '@mui/icons-material'
import { Modal, Table, Tooltip ,Input , Button as AntdButton  } from 'antd'
import { find } from 'lodash'
import moment from 'moment-timezone'
import queryString from 'query-string'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAllBook } from 'store/books/selectors'
import { useCurrentClass } from 'store/classes/selectors'
import { useClassStudentLogs, useIsUriMovable, useMessageAlertView, useMessageBroadcaster, useUrlBroadcaster } from 'store/live_logs/selectors'
import { useResources, useVideos } from 'store/resources/selectors'
import { useClassUsers } from 'store/userClasses/selectors'
import styled from "styled-components"
import { default as color, default as COLOR } from 'utils/constants/color'
import { getBookDisplayName } from 'utils/lib/ebookHelper'
import Loading from './Loading'
import activitySvg from "../utils/assets/images/activity.svg";
import starSvg from "../utils/assets/images/star.svg";
import Acent from './Acent'
import { message_alert_bg1, message_alert_bg2, message_alert_bg3 } from 'utils/assets/images'
import { useCurrentUser } from 'store/users/selectors'
import DemoPreview from './ViewDemoModal'
import { useAlert } from './UI/alertSakeBar/alertProvider';
import { useHowlAudio } from './hooks/useHowlProvider';
import Tag from 'components/Tag';
import SentryWrap from 'components/Sentry';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;


const MultiMenu = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
    variant: "menu",
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "top",
        horizontal: "left",
    },
    transformOrigin: {
        vertical: "bottom",
        horizontal: "left",
    },
};

const TableContainer = styled.div`
  margin-bottom: 20px;
`;
const CustomTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: rgb(239,246,254); 
  }
  .ant-table-tbody > tr > td {
    background-color: #fff; 
  }
`;
const CustomButton = styled(Button)`
    height: 30px;
    border-radius: 50px !important;
    margin-right: 10px !important;
`
const CustomBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    text-align: left;
    margin-left: 8px;
`;

const Note = styled.span`
  color: ${COLOR.black400};
  display: block;
  font-size: 13px !important;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 16px;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 5px;
  background:#fff;
  border-radius: 20px;
  position: relative;
  border: 1px solid;
  margin-top: 12px;
  @media (max-width: 432px){
    margin-bottom: 10px;
  }
`;

const CharacterCount = styled.span`
  position: absolute;
  right: 50px; 
  font-size: 12px;
  color: #a0a0a0;
`;

const StyledInput = styled(Input)`
  border: none;
  outline: none;
  background: transparent !important;
  &:focus {
    box-shadow: none;
  }
  flex-grow: 1;
`;

const StyledButton = styled(AntdButton)`
  background: transparent !important;
  border: none;
  margin-left: 5px;
  &:hover, &:focus {
    background: transparent !important;
    border: none;
  }
`;

const MoveButton = styled(Button)`
    &.Mui-disabled {
        cursor: not-allowed !important;
        color: #000 !important;
        background-color: #e9e9ff !important;
        pointer-events: all !important;
    }
`;

const IconWrapper = styled.div`
  max-height: 58px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background: transparent;
  z-index: 0;
  -webkit-transition: all 1s ease 0s;
  transition: all 1s ease 0s;
  cursor: pointer;
  margin-bottom: 5px;
`;
const fail_pass = {
    fail: "🔴",
    pass: "🟢",
    deactive:'⚪️',
    inactive:'🟡',
    not_same_page:'🔵'
}

const boardCastAudioUrl = {
    bubble_alert_pop_up: `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-07-30-a2a07e2a-a91c-4e9a-95f8-1feb925fa945mixkit-bubble-pop-up-alert-notification-2357.mp3?alt=media&token=ab8894c6-f32c-42bc-acdf-1331a4a949a0`,
    long_pop_up: `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/books%2FAudioPicker%2F2025-07-30-fdfaf27d-ce2d-4b2d-9af8-cd88d4a2abcemixkit-long-pop-2358.wav?alt=media&token=ef1b6180-0b96-4a4e-aaba-2f8b47591769`,
}

const ALERT_BG = [message_alert_bg1, message_alert_bg2, message_alert_bg3]
const DEFAULT_ALERT_POSTER = message_alert_bg1

const PosterSelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
`;

const PosterLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${COLOR.black400};
`;

const PosterOptions = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const PosterOption = styled.button`
  width: 72px;
  height: 48px;
  padding: 0;
  border-radius: 8px;
  border: 3px solid ${({ $selected }) => ($selected ? COLOR.indigo600 : 'transparent')};
  background-image: url(${({ $poster }) => $poster});
  background-size: cover;
  background-position: center;
  cursor: pointer;
  outline: none;
  box-shadow: ${({ $selected }) => ($selected ? `0 0 0 2px #fff, 0 0 0 4px ${COLOR.indigo600}` : '0 2px 4px rgba(0,0,0,0.15)')};
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const sortAndFormatUserData = (user_list_data) => {
    user_list_data.sort((a, b) => {
        // Sort by login_status first, placing false at the bottom
        if (a.login_status && !b.login_status) return -1;
        if (!a.login_status && b.login_status) return 1;

        // Sort by active status
        if (a.active && !b.active) return -1;
        if (!a.active && b.active) return 1;

        // Sort by page similarity
        if (a.has_same_page && !b.has_same_page) return -1;
        if (!a.has_same_page && b.has_same_page) return 1;

        // Sort by date, newer dates first
        const dateA = moment(a.last_modified);
        const dateB = moment(b.last_modified);
        return dateB.diff(dateA); 
    });
    return user_list_data;
};

const isAssignmentOpen = (value) => {
    return value !== false && value !== 'false' && value !== null && value !== undefined && value !== '' && value !== 'null';
};

const shouldShowAssignmentOpen = (student) => {
    if (!student) {
        return false;
    }

    return isAssignmentOpen(student.is_drawer_open) && student.lastVisitedPage !== '/student/class' && student.lastVisitedPage !== '/';
};




export default function ActiveStudentStatus({ style = {}, wrapperStyle = {}, activeStatus, setActiveStatus }) {
    const class_user_logs = useClassStudentLogs()
    const class_user = useClassUsers()
    const [user_list, setUserList] = useState([])
    const currentClass = useCurrentClass()
    const location = useLocation();
    const [ideaModal, setIdeaModal] = useState(false);
    function isSamePage(logs) {
        const { lastVisitedPage, query } = logs;
        const searchParams = queryString.parse(location.search);
        const currentPath = location.pathname
        if (lastVisitedPage == currentPath) {
            if (currentPath === '/stories') {
                return searchParams.id === query.id && searchParams.page === query.page && searchParams.level == query.level
            }
            else if (currentPath === '/apBook') {
                return searchParams.chapter === query.chapter && searchParams.id === query.id && searchParams.page == query.page
            }
            else if (currentPath === '/ebook') {
                return searchParams.chapter === query.chapter && searchParams.page == query.page
            }
            if (currentPath === '/informateBook' || currentPath === '/balconCulturalBook' || currentPath === '/ConectandomeBook' || currentPath === '/ComunidadBook') {
                return searchParams.id === query.id && searchParams.page === query.page
            }
            if (currentPath === '/video') {
                return searchParams.id === query.id
            }
            return true;
        }else if(lastVisitedPage === '/student/class' && currentPath ==='/admin/class'){
            return true
        }
        return false;
    }
    useEffect(() => {
        if (currentClass) {
            let user_list_data = [];
            class_user.forEach((user) => {
                if (user.role === 'student') {
                    const logs = class_user_logs.find(log => log.userId === user.id && log.classId === currentClass.id);
                    if (logs) {
                        const mintDif = moment().diff(logs.timestamp.toDate(), "minutes");
                        const isDrawerOpen = isAssignmentOpen(logs?.query?.activity) || isAssignmentOpen(logs?.query?.quiz);
                        user_list_data.push({
                            user_id: user.id,
                            name: `${user.lastName || ''}, ${user.firstName || ''}`,
                            has_same_path: logs.lastVisitedPage == location.pathname,
                            has_same_page: isSamePage(logs),
                            last_modified: moment(logs.timestamp.toDate()).toISOString(),
                            login_status: true, 
                            ...logs,
                            active: logs.active && logs.idle_time >= 0 ? mintDif - logs.idle_time < 30 : false,
                            is_drawer_open: isDrawerOpen
                        });
                    } else {
                        user_list_data.push({
                            user_id: user.id,
                            name: `${user.lastName || ''}, ${user.firstName || ''}`,
                            has_same_path: false,
                            has_same_page: false,
                            last_modified: null,
                            login_status: false,
                            active: false
                        });
                    }
                }
            });
            setUserList(sortAndFormatUserData(user_list_data));
        } else {
            setUserList([]);
        }
    }, [class_user_logs, class_user, currentClass, location, ideaModal]);
    
    const hideIdeaModal = () => {
        setIdeaModal(false)
        setActiveStatus(false)
        const mref = document.getElementsByClassName("msgSystemWrap")[0]
        if(mref){
            mref.classList.remove("msgSystemWrapIndex")
        }
    }
    const viewIdeaModal = () => {
        setIdeaModal(true)
        const mref = document.getElementsByClassName("msgSystemWrap")[0]
        if(mref){
            mref.classList.add("msgSystemWrapIndex")
        }
    }

    useEffect(() => {
        const classNames = ["overflow-hidden"];

        if (ideaModal || activeStatus) {
          document.body.classList.add(...classNames);
        } else {
          document.body.classList.remove(...classNames);
        }
        return () => {
          document.body.classList.remove(...classNames);
        };
      }, [ideaModal, activeStatus]);

    return (
        <SentryWrap>
        <div style={{ display:"flex",...wrapperStyle}}>
            <Modal
                visible={ideaModal || activeStatus}
                onCancel={hideIdeaModal}
                className='activeStudentModal activity-modal'
            >
                <IdeaContent user_list={user_list}/>
            </Modal>
            <IconWrapper
                onClick={viewIdeaModal}
                className="debateLogoBtnPart 1221"
            >
                <img src={activitySvg} id='debade_icon' alt="Student activity" title='Student activity' />
            </IconWrapper>
            {/* <CustomButton style={style}
                onClick={viewIdeaModal}
                className='activeStudentLogBtn vocDeskTab'>

            </CustomButton> */}
        </div>
        </SentryWrap>
    )
}


const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: '25px',
        width: '300px'
    },
    rootDif: {
        width: '200px'
    },
    rootDifFull: {
        width: "100%"
    },
    sizeSmall: {
        width: '55px',
        height: '25px'
    },
    checkedSwitch: {
        transform: 'translateX(30px) !important'
    },
    label: {
        textTransform: 'uppercase',
    },
    colorPrimary: {
        color: `${COLOR.green}!important`
    },
    formControl: {
        margin: '2px',
        width: "100%",
        minWidth: 120
    },
    formControlStudent: {
        backgroundColor: "#fff",
        maxWidth:"250px",
        "@media (max-width: 400px)": {
            maxWidth: "none",
            width: "100%"
        }
    },
    indeterminateColor: {
        color: "#f50057"
    },
    selectAllText: {
        fontWeight: 500
    },
    selectedAll: {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08)"
        }
    }
}));

function MultiSelecter({ options, onSelect , selectedUser }) {
    const classes = useStyles();
    const [selected, setSelected] = useState([]);

    const isAllSelected = useMemo(() => (options.length > 0 && selected.length === options.length), [options, selected]);
    const handleChange = (event) => {
        const value = event.target.value;
        if (value[value.length - 1] === "all") {
            setSelected(selected.length === options.length ? [] : options.map(k=>k.user_id));
            onSelect(selected.length === options.length ? [] : options.map(k=>k.user_id))
            return;
        }
        onSelect(value)
        setSelected(value);
    };
    useEffect(() => {
        setSelected(selectedUser)
    }, [selectedUser])
    function getStatus(item) {
        if (!item.active && !item.login_status) {
            return fail_pass.deactive;
        }
        
        if (!item.active) {
            return fail_pass.deactive;
        }
        
        if (!item.has_same_page && item.idle_time > 30) {
            return fail_pass.inactive;
        }
        
        if (item.active && item.has_same_page) {
            return fail_pass.pass;
        }
        
        if (item.active && !item.has_same_page) {
            return fail_pass.not_same_page;
        }
        
        return fail_pass.fail;
    }
    return (
        <FormControl variant="outlined" className={classes.formControlStudent}>
            <InputLabel id="mutiple-select-label" style={{ background: "linear-gradient(135deg, #f0f2f5 0%, #e8eaed 100%)" , padding: "0px 5px"}}>Select students</InputLabel>
            <Select
                labelId="mutiple-select-label"
                multiple
                value={selected}
                onChange={handleChange}
                displayEmpty
                renderValue={(selected) => (
                    <div className={classes.chips}>
                        {`${isAllSelected || selected.length == 0 ? "All students" : "Students(" + selected.length + ")"}`}
                    </div>
                )}
                className='activity-select-student'
                MenuProps={MultiMenu}
            >
                <MenuItem
                    value="all"
                    classes={{
                        root: isAllSelected ? classes.selectedAll : ""
                    }}
                >
                    <ListItemIcon>
                        <Checkbox
                            classes={{ indeterminate: classes.indeterminateColor }}
                            checked={isAllSelected}
                            indeterminate={
                                selected.length > 0 && selected.length < options.length
                            }
                        />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: classes.selectAllText }}
                        primary="Select All"
                    />
                </MenuItem>
                {options.map((option) => (
                    <MenuItem key={option.user_id} value={option.user_id}>
                        <ListItemIcon>
                            <Checkbox checked={Boolean(find(selected, k => k === option.user_id))} />
                        </ListItemIcon>
                        <ListItemText primary={`${option?.name?.length > 15 ? option?.name?.slice(0,15) + "..." : option?.name} ${getStatus(option)}`} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

function MessageSender({ onSend }) {
    const inputRef = useRef(null);
    const [message, setMessage] = useState('');
    const [selectedPoster, setSelectedPoster] = useState(DEFAULT_ALERT_POSTER);

    const handleInputChange = (e) => {
        setMessage(e.target.value.substring(0, 60)); 
    };
    const handleInputAcentChange = (e) => {
        if (e) {
            setMessage(e.substring(0, 60));
        }
    };

    const handleSend = () => {
        if (message.trim()) {
            onSend(message, selectedPoster);
            setMessage('');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };
    return (
        <div style={{position: "relative"}} className="moveAllStudentInputConteiner">
            <Acent
                inputRef={inputRef.current?.input} setValue={handleInputAcentChange}
                style={{
                    position: "absolute",
                    right: 0,
                    top: -30
                }} />
            <PosterSelectorWrapper>
                <PosterLabel>Select poster</PosterLabel>
                <PosterOptions>
                    {ALERT_BG.map((poster) => (
                        <PosterOption
                            key={poster}
                            type="button"
                            $poster={poster}
                            $selected={selectedPoster === poster}
                            onClick={() => setSelectedPoster(poster)}
                            aria-label="Select message poster"
                        />
                    ))}
                </PosterOptions>
            </PosterSelectorWrapper>
            <InputContainer>
                <StyledInput
                    ref={inputRef}
                    value={message}
                    onChange={handleInputChange}
                    onKeyPress={handleKeyPress}
                    placeholder="Send a message to students"
                    maxLength={60}
                    autoFocus
                />
                <CharacterCount>{`${message.length}/60`}</CharacterCount>
                <StyledButton
                    icon={<SendOutlined />}
                    onClick={handleSend}
                    disabled={!message.trim()} // Disable button if message is empty
                    type="text"
                />
            </InputContainer>
        </div>
    );

}


const IdeaContent = ({ user_list }) => {
    const showAlert = useAlert();
    const [loader,setLoader] = useState(false);
    const [broadcastloader,seBroadcasttLoader] = useState(false);
    const [selectedUsers,setSelectedUsers] = useState([]);
    const [messageSenderEnable,setMessageSenderEnable] = useState(false);
    const [assignmentModalVisible, setAssignmentModalVisible] = useState(false);
    const bookAllList = useAllBook()
    const urlBroadcaster = useUrlBroadcaster()
    const videos = useVideos();
    const resource = useResources();
    const isMovable = useIsUriMovable()
    const  broadcastMessageToClass  = useMessageBroadcaster()
    const sendAudioUrl = boardCastAudioUrl?.long_pop_up;
    const { playSound } = useHowlAudio();

    const bringStudent = useMemo(() => {
      let timeoutId = null;
      let isProcessing = false;
      
      return async () => {
        if (isProcessing) {
          showAlert('Please wait, students are already being moved...', 'warning');
          return;
        }
        
        const studentsToCheck = selectedUsers.length > 0 ? selectedUsers : user_list.map(u => u.user_id);
        const hasDrawerOpen = user_list.some(u => studentsToCheck.includes(u.user_id) && shouldShowAssignmentOpen(u));

        if (hasDrawerOpen) {
            setAssignmentModalVisible(true);
            return;
        }
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        
        timeoutId = setTimeout(async () => {
          isProcessing = true;
          setLoader(true);
          
          try {
            await urlBroadcaster();
            showAlert('Students are being moved to this page...', 'success');
          } catch (error) {
            console.error('Error moving students:', error);
            
            if (!error?.type) return;
            if (error.type === 'NON_ASSIGNABLE') {
              showAlert('Cannot move students to teacher-only content', 'error');
            } else if (error.type === 'HIDDEN_BOOK_GROUP') {
              showAlert('Cannot move students to hidden Book Group', 'error');
            } else if (error.type === 'HIDDEN_BOOK') {
              showAlert('Cannot move students to hidden content', 'error');
            } else if (error.type === 'INACTIVE_EXAM') {
              showAlert('Cannot move students to inactive exam', 'error');
            } else {
              showAlert('Failed to move students. Please try again.', 'error');
            }
          } finally {
            setLoader(false);
            isProcessing = false;
          }
        }, 500);
      };
    }, [urlBroadcaster, showAlert, selectedUsers, user_list]);
    function getCurrentLocation(path, v) {
        if(!path) return 'Not logged in'
        if (path === '/') return 'Home'
        if (path === '/stories' || path === '/story-levels') return 'Stories'
        if (path === '/apBook' || path === "/ap") return 'AP'
        if (path === '/ap-exams') return 'AP Exams'
        if (path === '/ebook') {
            const book = getBookDisplayName(bookAllList, v.query.chapter, false, videos, resource)
            if (book) {
                return book;
            }
            return 'Ebook'
        }
        if (path === '/informateBook' || path === '/informate') return 'Informate'
        if (path === '/1nformate') return 'Informate blog'
        if (path === '/balconCulturalBook' || path === '/balconCultural') return 'Balcón cultural'
        if (path === '/ConectandomeBook' || path === '/Conectandome') return 'Conectándome'
        if (path === '/ComunidadBook' || path === '/comunidad') return 'Comunidad'
        if (path === "/resources") return '1WAYRESOURCES'
        if (path === '/video') {
            const book = getBookDisplayName(bookAllList, v.query.id, true, videos, resource)
            if (book) {
                return book;
            }
            return '1WAYRESOURCES'
        }
        if (path === '/OneWayLessons') return '1WAYLESSONS'
        if (path === '/student/class') return 'Home'
        if (path === '/exams') return 'Exams'
        return path === "/" ? 'logout' : path.replace("/", '')
    }
    const getIdealTime = (idleTime, item) => {
        if (item.active) {
            if (idleTime > 0) {
                if (idleTime > 30) {
                    return `more than 30 minutes`
                } else {
                    return `${idleTime} minutes`
                }
            }
        }
        return ''
    }
    function getStatus(c, item) {
        
        const renderStatusTooltip = (title, icon) => (
            <Tooltip
                placement="top"
                trigger="hover"
                title={title}>
                <span>{icon}</span>
            </Tooltip>
        );

        if (!item.active && !item.login_status) {
            return renderStatusTooltip('Not logged in', fail_pass.deactive);
        }
        
        if (!item.active) {
            return renderStatusTooltip('No status', fail_pass.deactive);
        }
        
        if (!c && item.idle_time > 30) {
            return renderStatusTooltip('Inactive on page', fail_pass.inactive);
        }
        
        if (item.active && item.has_same_page) {
            return renderStatusTooltip('Active on this page', fail_pass.pass);
        }
        
        if (item.active && !item.has_same_page) {
            return renderStatusTooltip('Active on another page', fail_pass.not_same_page);
        }
        
        if (c) {
            return renderStatusTooltip('Active on this page', fail_pass.pass);
        }
   
        return renderStatusTooltip('Offline', fail_pass.fail);
    }
    function onChatClick(item) {
            let event = new CustomEvent("openChatWithUser", {
                detail: {
                    userId: item.user_id,
                    forceClick: true
                },
                bubbles: true,
                cancelable: true,
            });
            document.dispatchEvent(event);
    }
    async function sendBroadcastMessage(messageText, poster){
        seBroadcasttLoader(true);
        await broadcastMessageToClass(messageText, selectedUsers, poster)
        showAlert('Message sent successfully!',"success");
        if (sendAudioUrl) {
            playSound(sendAudioUrl, { volume: 0.7 });
        }
        setSelectedUsers([])
        setMessageSenderEnable(false)
        seBroadcasttLoader(false);
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (c, v) => (
                <span>
                    <Tooltip title={c}>
                        {window.innerWidth > 500 ? c : c?.length > 5 ? c?.slice(0,5) + "..." : c}
                    </Tooltip>
                    <CustomBtn onClick={() => {
                        onChatClick(v);
                    }}>
                        <Chat style={{ fontSize:14 }} />
                    </CustomBtn>
                </span>
            )
        },
        // {
        //     title: 'Last action',
        //     dataIndex: 'time_ago',
        //     key: 'time_ago'
        // },
        {
            title: 'Current location',
            dataIndex: 'lastVisitedPage',
            key: 'lastVisitedPage',
            render: (c, v) => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>
                        {getCurrentLocation(c, v)}
                    </span>
                    {shouldShowAssignmentOpen(v) && (
                        <span style={{ fontSize: '10px', color: '#1890ff', fontWeight: 'bold' }}>
                            (Assignment Open)
                        </span>
                    )}
                </div>
            )
        },
        // {
        //     title: 'Active',
        //     dataIndex: 'active',
        //     key: 'active',
        //     render: c => (
        //         <span style={{ color: c ? color.green : color.red }}>
        //             {c ? fail_pass.pass : fail_pass.fail}
        //         </span>
        //     )
        // },
        {
            title: 'Active on this page',
            dataIndex: 'has_same_page',
            key: 'has_same_page',
            render: (c,item) => (
                <span>
                    {getStatus(c, item)}
                </span>
            )
        },
        {
            title: 'Idle time',
            dataIndex: 'idle_time',
            key: 'idle_time',
            render: (c,item) => (
                <span style={{ color: color.OrangeExam }}>
                    {getIdealTime(c,item)}
                </span>
            )
        }
    ];

    const [scrollY, setScrollY] = useState(`calc(80vh - 250px)`);

    useEffect(() => {
        const updateScrollY = () => {
          if (window.innerWidth <= 500) {  
            setScrollY(`calc(40vh - 100px)`);
          } else if (window.innerWidth <= 768) {  
            setScrollY(`calc(60vh - 150px)`);
          } else {  
            setScrollY(`calc(80vh - 250px)`);
          }
        };
    
        updateScrollY(); 
        window.addEventListener('resize', updateScrollY);
    
        return () => {
          window.removeEventListener('resize', updateScrollY); 
        };
      }, []);
    const moveStudentsToPage = async () => {
        await urlBroadcaster();
    };
    const handleCancelMove = () => {
        setAssignmentModalVisible(false);
    };

    const getStudentsTakingAssignmentIds = () => {
      const studentsToCheck =
        selectedUsers.length > 0
          ? selectedUsers
          : user_list.map(u => u.user_id);

      return user_list
        .filter(
          u =>
            studentsToCheck.includes(u.user_id) &&
            shouldShowAssignmentOpen(u)
        )
        .map(u => u.user_id);
    };

    const handleContinueMove = async () => {
      setLoader(true);
    
      try {
        await moveStudentsToPage();
        const studentsTakingAssignment = getStudentsTakingAssignmentIds();
        if (studentsTakingAssignment.length > 0) {
          broadcastMessageToClass('You are being moved to another page by your teacher.', studentsTakingAssignment, DEFAULT_ALERT_POSTER);
        }
        setAssignmentModalVisible(false);
    
      } catch (error) {
        console.error('Continue move failed:', error);
        if (!error?.type) return;
        if (error.type === 'NON_ASSIGNABLE') {
          showAlert('Cannot move students to teacher-only content', 'error');
        } else if (error.type === 'HIDDEN_BOOK_GROUP') {
          showAlert('Cannot move students to hidden Book Group', 'error');
        } else if (error.type === 'HIDDEN_BOOK') {
          showAlert('Cannot move students to hidden content', 'error');
        } else if (error.type === 'INACTIVE_EXAM') {
          showAlert('Cannot move students to inactive exam', 'error');
        } else {
          showAlert('Failed to move students. Please try again.', 'error');
        }
      } finally {
        setLoader(false);
      }
    };
    const getStudentsTakingAssignmentList = () => {
      const studentIds = getStudentsTakingAssignmentIds();
      return user_list
        .filter(u => studentIds.includes(u.user_id))
        .map(u => {
          if (!u.name) return null;
          const parts = u.name.split(',').map(p => p.trim());
          return parts.length === 2 ? `${parts[1]} ${parts[0]}` : u.name;
        })
        .filter(Boolean);
    };

    return (
        <div>
            <Modal
                visible={assignmentModalVisible}
                onCancel={handleCancelMove}
                footer={[
                    <AntdButton key="cancel" onClick={handleCancelMove} disabled={loader}>
                        Cancel
                    </AntdButton>,
                    <AntdButton key="continue" type="primary" onClick={handleContinueMove} loading={loader}>
                        Continue
                    </AntdButton>
                ]}
                title="Students Taking the Assignment"
            >
                <div style={{ padding: '20px 0' }}>
                    <p style={{ marginBottom: '16px', fontSize: '16px' }}>
                        The following students are currently working on an assignment:
                    </p>
                    <ul style={{ paddingLeft: '20px', marginBottom: '16px', maxHeight: '150px', overflowY: 'auto'}}>
                      {getStudentsTakingAssignmentList().map((name, index) => (
                        <li key={index} style={{ marginBottom: '6px', fontWeight: 500 }}>
                          {name}
                        </li>
                      ))}
                    </ul>
                    <div>
                    <Tag bgColor={COLOR.redishpink} gap={4}><img src={starSvg} alt="" /><strong style={{ fontSize: 10 }}>NOTE</strong></Tag>
                     <Note style={{ color: COLOR.black400 }}>Students will be redirected to this page, and their current assignment’s microphone or camera access will be disabled. If they are currently recording, the recording will be stopped automatically.</Note>
                    </div>
                    <p style={{ marginBottom: '0', fontSize: '14px', color: '#666' }}>
                        Click Continue to move them anyway, or Cancel to stop.
                    </p>
                </div>
            </Modal>
            <div className='activeStudentMdlContent'>
                <div className="activeDemoPreview"><DemoPreview video_id={"student-activity-demo"} wrapperStyle={{ justifyContent: "flex-end"}} /></div>
                <TableContainer>
                    <CustomTable columns={columns} dataSource={user_list} rowKey="user_id" pagination={{ position: "bottomRight" }} sticky  scroll={{ y: scrollY }} />
                    <div className='-mt-45px sm-mt-0' style={{ display: "flex", flexDirection: "row", gap: 5 }}>
                        <MoveButton
                            onClick={bringStudent}
                            disabled={!isMovable || loader}
                            endIcon={loader ? <Loading size={14} white /> : null}
                            className='activeStudentLogBtn'>
                            {loader ? 'MOVING STUDENTS...' : 'MOVE ALL STUDENTS TO THIS PAGE'}
                        </MoveButton>
                    </div> 
                </TableContainer>
                <div className="activitySelectButton">
                    <MultiSelecter options={user_list} selectedUser={selectedUsers} onSelect={setSelectedUsers} />
                    <MessageSender onSend={sendBroadcastMessage} />
                </div> 
            </div>
        </div>
    );
};
export const MessageAlertViewer = () => {
    const { messageAlertView, revokeMessageAlert } = useMessageAlertView()
    const currentUser = useCurrentUser()
    const bg = messageAlertView.poster || DEFAULT_ALERT_POSTER;
    const sendAudioUrl = boardCastAudioUrl?.bubble_alert_pop_up;
    const { playSound } = useHowlAudio();

    useEffect(() => {
        if (messageAlertView.view && sendAudioUrl) {
            const timer = setTimeout(() => {
                playSound(sendAudioUrl, { volume: 0.7 });
            }, 100);
            
            return () => clearTimeout(timer);
        }
    }, [messageAlertView.view]);
    if (!currentUser || currentUser.role != 'student') {
        return null;
    }
    return (<MuiModal
        open={messageAlertView.view}
        onClose={revokeMessageAlert}
        style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
    >
        <FeedBackWrapper>
            <FeedbackContainer bg={bg}>
            <CloseBtn onClick={revokeMessageAlert}>
                        <Close style={{ color: "#fff", fontWeight: "bolder", fontSize: 35 }} />
                    </CloseBtn>
           <AlertTitle>{messageAlertView.message || ""}</AlertTitle>
            </FeedbackContainer>
        </FeedBackWrapper>
    </MuiModal>)
}



const FeedBackWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: transparent;
`;
const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 60%;
  background-color: rgb(58, 58, 58);
  background-image: url(${p => p.bg});
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  padding: 20px;
  padding-top: 0px;
  aspect-ratio: 16 / 9;

   @media (max-width: 1500px) { /* Tablet screens, typically up to 768px */
    min-height: 40%;
  }

  @media (max-width: 1000px) { /* Tablet screens, typically up to 768px */
    min-height: 40%;
  }

   @media (max-width: 980px) { /* Tablet screens, typically up to 768px */
    min-height: 29%;
  }

  @media (max-width: 768px) { /* Tablet screens, typically up to 768px */
    min-height: 28%;
  }

  @media (max-width: 700px) { /* Mobile screens, typically up to 480px */
    width: 100%;
  }
`;
const CloseBtn = styled.div`
    background-color: rgb(204,80,71);
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    z-index: 1;
`;

const AlertTitle = styled.div`   
    font-weight: bold;
    margin-bottom: 5px;
    white-space: pre-line;
    text-align: center;
    width: 100%;
    color: #fff;
    max-width: 80%;
    align-self: center;
    margin-top: 20%;
    font-family: 'Arial Black', 'Impact', sans-serif;
    padding: 10px;
    font-size: calc(16px + 0.5vw); /* Starting font size for small screens with a bit of scaling */

    @media (min-width: 1200px) {
        font-size: 24px; /* Fixed font size for large screens */
    }

    @media (max-width: 768px) {
        font-size: calc(16px + 0.5vw); 
    }

    @media (max-width: 480px) {
        font-size: calc(12px +  0.5vw); 
    }
`;